import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { landingPalette } from '../landing-theme';

/**
 * The small uppercase kicker that opens most landing sections.
 *
 * Extracted because the same six-property treatment appears in every section — a tweak to
 * the kicker must not mean editing five files.
 */
export function LandingEyebrow(props: { children: string; sx?: SxProps<Theme> }) {
  return (
    <Typography
      sx={[
        {
          mb: 2,
          color: landingPalette.accent,
          fontSize: '.78rem',
          fontWeight: 700,
          letterSpacing: '.16em',
          textTransform: 'uppercase',
        },
        ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
      ]}
    >
      {props.children}
    </Typography>
  );
}
